/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { Typography, Box } from '@mui/material';
import { UtmCloseIcons, DuplicateIcon } from '../../icons';
import QrCodeModal from './QrCodeModal';
import { buildCampaignLink } from '../../containers/campaign-container/utils';
export default function GenerateLinkModal({ onClose, open, data }) {
    const [copiedIndex, setCopiedIndex] = React.useState(null);
    const [isShort, setIsShort] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);

    // Build the UTM link from campaign data
    const link = React.useMemo(() => {
        return buildCampaignLink(data);
    }, [data]);

    // Reset states when modal opens or closes
    React.useEffect(() => {
        if (!open) {
            setCopiedIndex(null);
            setIsShort(false);
        }
    }, [open]);

    const handleCopy = (text, index) => {
        if (!text || text === '-') return;
        navigator.clipboard.writeText(text);
        setCopiedIndex(index);
        setTimeout(() => {
            setCopiedIndex(null);
        }, 1500);
    };

    const handleClickModal = () => {
        setIsOpen(true);
    };

    const handleCloseModal = () => {
        setIsOpen(false);
    };

    const getShortLink = (url) => {
        if (!url || url === '-') return '-';
        if (url.length <= 40) return url;
        return url.slice(0, 40) + '...';
    };

    return (
        <React.Fragment>

            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiPaper-root': {
                        padding: '20px 14px',
                        width: '500px',
                        borderRadius: '7px'
                    }
                }}
            >
                <Box>
                    <Box sx={{ marginBottom: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>
                        <Box>
                            <Typography sx={{ color: '#101828', fontWeight: '500', fontSize: '18px', fontFamily: 'Neue Montreal' }}>Generated UTM Link</Typography>
                            <Typography sx={{ color: '#4A5565', fontWeight: '400', fontSize: '14px', fontFamily: 'Neue Montreal' }}>
                                Campaign Name: {data?.campaignName}
                            </Typography>
                        </Box>
                        <UtmCloseIcons onClick={onClose} />
                    </Box>


                    <Box sx={{}}>
                        <Box
                            sx={{
                                border: '1px dashed #2E80DB',
                                padding: '7px',
                                borderRadius: '7px',
                                background: '#F8FAFC',
                                width: '100%',
                                marginBottom: '12px'
                            }}
                        >
                            <a
                                href={link !== "-" ? link : undefined}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: '#2E80DB',
                                    textDecoration: 'underline',
                                    fontSize: '14px',
                                    wordBreak: 'break-all'
                                }}
                            >
                                {isShort ? getShortLink(link) : link}
                            </a>
                        </Box>
                        <Box>

                            <Box sx={{ display: 'flex', gap: '10px' }}>
                                <Box
                                    onClick={() => handleCopy(link, 0)}
                                    sx={{
                                        border: '1px solid #ddd',
                                        padding: '7px',
                                        borderRadius: '7px',
                                        cursor: link !== '-' ? 'pointer' : 'default',
                                        position: 'relative', width: '100%',
                                        textAlign: 'center',
                                        opacity: link === '-' ? 0.5 : 1,
                                        '&:hover': link !== '-' ? { background: '#f5f5f5' } : {}
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: 'Neue Montreal',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            color: '#3E3E3E'
                                        }}
                                    >
                                        Copy <DuplicateIcon />
                                    </Typography>

                                    {copiedIndex === 0 && (
                                        <span
                                            style={{
                                                position: 'absolute',
                                                top: '-25px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                background: '#000',
                                                color: '#fff',
                                                padding: '3px 10px',
                                                borderRadius: '20px',
                                                fontSize: '10px'
                                            }}
                                        >
                                            Copied
                                        </span>
                                    )}
                                </Box>
                                {/*
                                <Box
                                    onClick={handleToggleShorten}
                                    sx={{
                                        border: '1px solid #ddd',
                                        padding: '7px',
                                        borderRadius: '7px',
                                        width: '100%',
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        background: isShort ? '#F0F9FD' : 'transparent',
                                        '&:hover': { background: '#f5f5f5' }
                                    }}
                                >
                                    <Typography sx={{
                                        fontFamily: 'Neue Montreal',
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        color: '#3E3E3E'
                                    }}>
                                        {isShort ? 'Full Link' : 'Shorten'}
                                    </Typography>
                                </Box>
                                */}
                                <Box onClick={() => {
                                    handleClickModal()
                                    onClose()
                                }} sx={{
                                    border: '1px solid #ddd', padding: '7px', borderRadius: '7px', width: '100%',
                                    textAlign: 'center', cursor: 'pointer',
                                    '&:hover': { background: '#f5f5f5' }
                                }}>
                                    <Typography sx={{ fontFamily: 'Neue Montreal', fontSize: '14px', fontWeight: '400', color: '#3E3E3E' }}>
                                        QR Code
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Dialog>

            <QrCodeModal open={isOpen} onClose={handleCloseModal} link={link} campaignName={data?.campaignName} />
        </React.Fragment>
    );
}
